import { Injectable } from "@nestjs/common";
import { Calibrations } from "../calibration.entity";
import { CalibrationDto } from "./calibration.dto";

@Injectable()
export class CalibrationAdapter{
     
    public convertDtoToEntity(dto: CalibrationDto, isUpdate: boolean = false): Calibrations {
        const entity = new Calibrations();
        entity.calibrationId = dto.calibrationId;
        entity.machineDescription = dto.machineDescription;
        entity.barcodeNo = dto.barcodeNo;
        entity.instrument = dto.instrument;
        entity.instrumentMake = dto.instrumentMake;
        entity.modelType = dto.modelType;
        entity.serialNo = dto.serialNo;
        entity.plant =dto.plant
        entity.calibrationRange = dto.calibrationRange;
        if (dto.calibrationDueOn instanceof Date) {
            entity.calibrationDueOn = dto.calibrationDueOn.toISOString().split('T')[0] as unknown as Date;
        } else {
            const dueOnDate = new Date(dto.calibrationDueOn);
            entity.calibrationDueOn = dueOnDate.toISOString().split('T')[0] as unknown as Date;
        }
        entity.calibrationFrequency = dto.calibrationFrequency;
        entity.location = dto.location;
        entity.isActive = dto.isActive == undefined ? true : dto.isActive;
        if (isUpdate) {
            entity.updatedUser = dto.updatedUser;
        } else {
            entity.isActive = true;
            entity.createdUser = dto.createdUser;
        }
        return entity;
    }

    public convertEntityToDto(entity: Calibrations): CalibrationDto {
        const dto = new CalibrationDto();
        dto.calibrationId = entity.calibrationId;
        dto.machineDescription = entity.machineDescription;
        dto.barcodeNo = entity.barcodeNo;
        dto.instrument = entity.instrument;
        dto.instrumentMake = entity.instrumentMake;
        dto.modelType = entity.modelType;
        dto.serialNo = entity.serialNo;
        dto.calibrationRange = entity.calibrationRange;
        dto.calibrationDueOn = entity.calibrationDueOn;
        dto.calibrationFrequency = entity.calibrationFrequency;
        dto.location = entity.location;
        dto.plant = entity.plant
        dto.isActive = entity.isActive;
        dto.createdAt = entity.createdAt;
        dto.createdUser = entity.createdUser;
        dto.updatedAt = entity.updatedAt;
        dto.updatedUser = entity.updatedUser;
        dto.versionFlag = entity.versionFlag;
        dto.filePath = ''
        return dto;
    }
    
}
